import NotificationCenter from "@/views/NotificationCenter.vue";

const routes = [
  {
    path: "/centro-notifiche",
    component: NotificationCenter,
    name: "notification-center",
  },
];

export default routes;
